import React from 'react';
import styled from 'styled-components';

const PrivacyPolicy = () => {
return (
<BodyWrap>
    <Nav>
        <div className="nav-content">UST PEST SERVICE</div>
    </Nav>
    <Container>
        <h1>Privacy Policy</h1>
        <p className="intro">Your privacy is important to us. We only collect what is necessary.</p>

        <Card>
            <h2>1. Data Collection</h2>
            <p>We collect only the following information to provide our services:</p>
            <ul>
                <li><strong>Email Address:</strong> For account identification and security.</li>
                <li><strong>Password:</strong> Stored securely using industry-standard encryption.</li>
            </ul>
        </Card>

        <Card>
            <h2>2. Use of Information</h2>
            <p>Your data is used solely for authentication and service updates. We do not sell your personal data to third parties.</p>
        </Card>

        <Card>
            <h2>3. Account Deletion & Rights</h2>
            <p>In compliance with India's <i>DPDP Act</i>, you have the right to access or delete your data.</p>
            <p>
                <strong>To delete your account:</strong> Please submit a request through our
                <a href="https://manage.ustind.in/info/support" className="link-text"> Support Page</a>.
                Once we receive your enquiry, our team will verify your identity and permanently erase your account data within 30 days.
            </p>
        </Card>

        <Footer>
            &copy; 2026 MKB Global Service Private Inc. All rights reserved. support.mkb@gmail.com
        </Footer>
    </Container>
</BodyWrap>
);
};

export default PrivacyPolicy;

/* Styled Components */

const BodyWrap = styled.div`
margin: 0;
font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
background: #f5f5f7;
color: #1d1d1f;
line-height: 1.6;
min-height: 100vh;
`;

const Nav = styled.nav`
height: 44px;
background: rgba(255, 255, 255, 0.8);
backdrop-filter: blur(20px);
display: flex;
align-items: center;
border-bottom: 1px solid #d2d2d7;
position: sticky;
top: 0;
z-index: 100;

.nav-content {
max-width: 800px;
margin: 0 auto;
width: 100%;
padding: 0 20px;
font-weight: 600;
}
`;

const Container = styled.main`
max-width: 800px;
margin: 0 auto;
padding: 60px 20px;

h1 {
font-size: 40px;
font-weight: 700;
letter-spacing: -0.015em;
margin-bottom: 10px;
}

.intro {
font-size: 21px;
color: #86868b;
margin-bottom: 40px;
}
`;

const Card = styled.div`
background: #fff;
padding: 30px;
border-radius: 18px;
margin-bottom: 20px;
box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

h2 {
font-size: 22px;
margin-top: 0;
border-bottom: 1px solid #f5f5f7;
padding-bottom: 10px;
}

ul {
padding-left: 20px;
}

li {
margin-bottom: 10px;
}

.link-text {
color: #0066cc;
text-decoration: none;
&:hover {
text-decoration: underline;
}
}
`;

const Footer = styled.footer`
text-align: center;
padding: 40px 0;
color: #86868b;
font-size: 12px;
`;
